module.exports = __webpack_public_path__ + "static/media/Profile 3.8f8c588c.svg";